module.exports = __webpack_public_path__ + "img/image3.5ccdee98.png";